(function ($) {
    $(document).ready(function () {

        const section = $(".section-images_slider_with_list");

        const time = 3000, speed = 500;

        const swiperOptions = {
            loop: true,
            spaceBetween: 20,
            slidesPerView: "auto",
            allowTouchMove: true,
            autoplay: {
                delay: time,
                disableOnInteraction: false
            },
            speed: speed,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
        };

        const slider = new Swiper(".section-images_slider_with_list .swiper", swiperOptions);

    })
})(jQuery);